export default "__VITE_ASSET__CeGM0BJg__"